export default "__VITE_ASSET__A9dC2kOP__"